import React from 'react';
import useDisableEnterKey from '../../hooks/useDisableAllKeys';
import * as SOL from "../../styles/solda/StyledComponentSol";

interface ModalCloseProps {
  isOpen: boolean;
  onClose: () => void;
  text: string;
}

const ModalClose: React.FC<ModalCloseProps> = ({ isOpen, onClose, text }) => {
  useDisableEnterKey(isOpen);
  if (!isOpen) return null;
  return (
    <SOL.ModalOverlay>
      <div className="modal">
        <div className='modal-wrapper'>
          <h3>알림</h3>
          <p className='modal-text'>{text}</p>
          <button className="modal-confirm-btn" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </SOL.ModalOverlay>
  );
};

export default ModalClose;
